import { render, staticRenderFns } from "./FooterBarCopyRight.vue?vue&type=template&id=36d19b6d&scoped=true"
import script from "./FooterBarCopyRight.vue?vue&type=script&lang=js"
export * from "./FooterBarCopyRight.vue?vue&type=script&lang=js"
import style0 from "./FooterBarCopyRight.vue?vue&type=style&index=0&id=36d19b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d19b6d",
  null
  
)

export default component.exports